const RATES: Record<string, number> = {
  TTD: 1, USD: 0.147, JMD: 22.3, BBD: 0.295,
  ECS: 0.397, GYD: 32.5, SRD: 5.2,
};

const SYMBOLS: Record<string, string> = {
  TTD: 'TT$', USD: '$', JMD: 'J$', BBD: 'Bds$',
  ECS: 'EC$', GYD: 'G$', SRD: 'Sr$',
};

export const CURRENCY_CODES = Object.keys(RATES);

export function formatPrice(amount: number, fromCurrency: string, toCurrency: string): string {
  const converted = amount * (RATES[toCurrency] / RATES[fromCurrency]);
  return `${SYMBOLS[toCurrency]} ${converted.toFixed(2)}`;
}

export function convertAmount(amount: number, from: string, to: string): number {
  return amount * (RATES[to] / RATES[from]);
}

export function getCurrencySymbol(code: string): string {
  return SYMBOLS[code] || code;
}
